var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.spans),function(span){return _c('span',_vm._b({key:span.id,class:_vm.getSpanClasses(span),style:(_vm.getSpanStyle(span)),attrs:{"data-span-id":span.id,"id":_vm.getSpanID(span)},on:{"click":_vm.spanEvent}},'span',_vm.spanAttributes,false),[_vm._v(_vm._s(span.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }